import React, { FC } from 'react';
import cn from 'classnames';
import Check from '@crehana/crehana-icons/lib/CheckNew';
import parseClassnames from '../helpers/parseClassnames';
import transition from '../styles/transition';
import { greenMain } from '../styles/colors';
import { OPTION, OPTION_DARK } from './classnames';
import { MenuItemProps } from './types';

const MenuItem: FC<MenuItemProps> = ({
  jsxLabel,
  label,
  selected,
  clampText,
  dark,
  className = '',
  datatestid,
  'data-testid': dataTestId,
  ...other
}) => {
  const Tag: keyof JSX.IntrinsicElements = other.href ? 'a' : 'button';

  return (
    <Tag
      className={parseClassnames(className, dark ? OPTION_DARK : OPTION)}
      style={{
        transition: transition(['background-color', 'color']),
      }}
      data-testid={dataTestId || datatestid}
      {...other}
    >
      <span
        className={cn('font-body3 overflow-hidden max-h-24', {
          'pr-16': selected,
          'break-all truncate': clampText,
        })}
      >
        {jsxLabel || label}
      </span>
      {selected && <Check size={24} color={greenMain} />}
    </Tag>
  );
};

export default MenuItem;
